// ArChat Language Extension
// Created: 13-03-2026 00:00:00
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';

export const plansTranslationsEl = {
  ...plansTranslationsEn,
  'plans.modal.title': 'Αναβάθμιση πλάνου',
  'plans.modal.comparison_title': 'Σύγκριση πλάνων',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Δωρεάν πλάνο',
  'plans.free.features.contacts': 'Έως 2 επαφές ανά χρήστη',
  'plans.free.features.conversations': 'Έως 2 ενεργές συνομιλίες ανά λογαριασμό',
  'plans.free.features.no_export': '30.000 χαρακτήρες/μήνα ανά λογαριασμό· 34 μηνύματα/ημέρα και 1.000/μήνα· χωρίς εξαγωγή',
  'plans.free.features.no_advanced': 'Χωρίς αρχεία ή αποθήκευση· ιστορικό 30 ημερών· 1 συσκευή ανά χρήστη',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Πλάνο Founder',
  'plans.foundation.features.contacts': 'Ίδιο premium συμβόλαιο με PRO (έως 100 επαφές ανά χρήστη)',
  'plans.foundation.features.conversations': 'Απεριόριστες συνομιλίες (tenant)· ίδια όρια με PRO',
  'plans.foundation.features.badge': 'Πρόγραμμα Founder (150 αριθμημένες θέσεις)',
  'plans.foundation.features.support': 'USD 15/μήνα όσο υπάρχουν θέσεις Founder',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Πλάνο Pro',
  'plans.pro.price': '$19 / μήνα',
  'plans.pro.features.contacts': 'Έως 100 επαφές ανά χρήστη',
  'plans.pro.features.conversations': 'Απεριόριστες συνομιλίες (tenant)· 1.667 μηνύματα/ημέρα, 50k/μήνα',
  'plans.pro.features.export': 'Έως 50 MB (tenant)· εξαγωγή, αυτόματη μετάφραση και αρχεία σύμφωνα με το πλάνο',
  'plans.pro.features.notifications': 'Έως 3 συσκευές ανά χρήστη· απεριόριστες προσκλήσεις (tenant)',
  'plans.actions.free': 'Τρέχον πλάνο',
  'plans.actions.foundation': 'Γίνε Founder',
  'plans.actions.pro': 'Αναβάθμιση σε PRO',
  'plans.badges.recommended': 'ΠΡΟΤΕΙΝΟΜΕΝΟ',
  'plans.badges.limited': 'ΠΕΡΙΟΡΙΣΜΕΝΟ',
  'plans.compare.title': 'Επιλέξτε πλάνο',
  'plans.compare.cta.foundation': 'Γίνε Founder',
  'plans.compare.cta.pro': 'Αναβάθμιση σε PRO',
  'plans.compare.active': 'Τρέχον πλάνο',
  'plans.limit.reached': 'Το όριο έφτασε — Αναβάθμιση πλάνου',
  'plans.compare.pro.adjustment_notice': 'Η τιμή μπορεί να προσαρμοστεί ανάλογα με τους όρους της υπηρεσίας.',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150 limited slots',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Message limit reached',
  'plans.limit.message.messages': 'You reached your message limit. Upgrade to FOUNDATION or PRO.',
  'plans.limit.title.storage': 'Storage limit reached',
  'plans.limit.message.storage': 'You reached your storage limit. Upgrade to upload more files.',
  'plans.limit.title.invitations': 'Invitation limit reached',
  'plans.limit.message.invitations': 'You reached your invitation limit. Upgrade to invite more.',
  'plans.founder.remaining': '{count} Founder seats remaining',
  'plans.founder.remaining_last': 'Last {count} Founder seats',
  'plans.founder.remaining_limited': 'Limited: {count} seats left',
  'plans.founder.remaining_very_low': 'Only {count} Founder seats left',
  'plans.founder.soldout': 'Founder sold out',
  'plans.compare.institucional.title': 'Θεσμικό',
  'plans.compare.yourPlan': 'Το πλάνο σου',
  'plans.badges.foundation': 'Founder',
  'plans.modal.free.line1': '30.000 χαρακτήρες ανά μήνα ανά λογαριασμό.',
  'plans.modal.free.line2': 'Έως 2 επαφές ανά χρήστη.',
  'plans.modal.free.line3': 'Έως 2 ενεργές συνομιλίες ανά λογαριασμό.',
  'plans.modal.free.line4': 'Χωρίς συνημμένα ή χώρο αποθήκευσης.',
  'plans.modal.free.line5': 'Χωρίς εξαγωγή δεδομένων.',
  'plans.modal.free.line6': 'Ιστορικό μηνυμάτων έως 30 ημέρες.',
  'plans.modal.free.line7': 'Μόνο 1 συσκευή ανά χρήστη.',
  'plans.modal.premium.line1': '300.000 χαρακτήρες ανά μήνα ανά λογαριασμό.',
  'plans.modal.premium.line2': 'Έως 100 επαφές ανά χρήστη.',
  'plans.modal.premium.line3': 'Απεριόριστες συνομιλίες και συνομιλίες τύπου chat (tenant).',
  'plans.modal.premium.line4': 'Έως 50 MB αποθήκευσης (tenant).',
  'plans.modal.premium.line5': 'Έως 3 συσκευές ανά χρήστη.',
  'plans.modal.premium.line6': 'Απεριόριστες προσκλήσεις (tenant).',
  'plans.modal.premium.line7': 'Περιλαμβάνει εξαγωγή, αυτόματη μετάφραση και αρχεία εντός των ορίων του πλάνου.',
  'plans.modal.premium_block_heading': 'Όρια χρήσης κινητήρα (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Πρόγραμμα Founder',
  'plans.modal.foundation.categories_title': 'Κατηγορίες Founder ({slots} θέσεις)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Θέση 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'Οι πρώτοι που στήριξαν το έργο. Μέγιστη ιστορική προτεραιότητα.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Θέση 26–75',
  'plans.modal.foundation.cat_early_desc': 'Νωρίς υποστήριξη με ειδική αναγνώριση.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Θέση 76–150',
  'plans.modal.foundation.cat_std_desc': 'Θέση Founder εντός των 150.',
  'plans.modal.foundation.advantages_title': 'Οφέλη Founder',
  'plans.modal.foundation.adv1': 'Πρόσβαση στο περιορισμένο σύνολο Founder ({slots} αριθμημένες θέσεις).',
  'plans.modal.foundation.adv2': 'Αναγνώριση ως ιδρυτικός χρήστης της ArChat.',
  'plans.modal.foundation.adv3': 'Σήμα και παρουσία Founder στην εμπειρία προϊόντος.',
  'plans.modal.foundation.adv4': 'Ιστορική προτεραιότητα και κατάσταση ανάλογα με τη θέση σας (1–150).',
  'plans.modal.foundation.adv5': 'Διαρκές όφελος συνδεδεμένο με την πρόσβαση Founder όσο ισχύει η τρέχουσα πολιτική.',
  'plans.modal.pro.tagline': 'Τυπικό premium — χωρίς στοιχείο Founder',
  'plans.payments_disabled.title': 'Συνδρομές',
  'plans.payments_disabled.message': 'Οι συνδρομές ενεργοποιούνται σταδιακά. Μπορείτε να δείτε τα διαθέσιμα πλάνα και τα πλεονεκτήματά τους.',
  'plans.payments_disabled.confirm': 'OK',
};